const WildixXMPPEvents = {
    // Designates an event indicating that a participant joined the XMPP MUC.
    MUC_MEMBER_JOINED: 'wildix.xmpp.muc_member_joined',
    CONTROL_SHARING_DATA: 'controlSharingData',
    TRANSCRIPTION_LANGUAGE: 'transcription_language',
    TRANSCRIPTION_LANGUAGE_STATUS: 'transcription_status'
};
export default WildixXMPPEvents;
